'use client';

import { useEffect } from 'react';

import { analytics } from '@kit/analytics';

interface TrackOrgPageviewProps {
  organizationId: string;
  /**
   * Suppress the capture for viewers who shouldn't be counted —
   * org members viewing their own org, super-admins doing moderation.
   * Keeps the visitor count meaningful for the org owner.
   */
  skip?: boolean;
}

export function TrackOrgPageview({
  organizationId,
  skip = false,
}: TrackOrgPageviewProps) {
  useEffect(() => {
    if (skip) return;
    void analytics.trackEvent('org_profile_viewed', {
      organization_id: organizationId,
    });
  }, [organizationId, skip]);

  return null;
}
